import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

/** A Terms & Conditions entry (Content is rich HTML from the editor). */
export interface TermsCondition {
  id: number;
  title: string;
  content: string;
  isActive: boolean;
  displayOrder: number;
  createdAt?: string | null;
  updatedAt?: string | null;
}

@Injectable({ providedIn: 'root' })
export class TermsService {
  private http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/TermsCondition`;

  /** Admin: every T&C entry. */
  getAll() {
    return this.http.get(`${this.base}/GetAll`);
  }
  /** Onboarding: only the active entries, ordered. */
  getActive() {
    return this.http.get(`${this.base}/GetActive`);
  }
  getById(id: number) {
    return this.http.get(`${this.base}/GetById`, { params: { id } });
  }
  upsert(body: Partial<TermsCondition>) {
    return this.http.post(`${this.base}/Upsert`, body);
  }
  enable(id: number) {
    return this.http.get(`${this.base}/Enable`, { params: { id } });
  }
  disable(id: number) {
    return this.http.get(`${this.base}/Disable`, { params: { id } });
  }
  delete(id: number) {
    return this.http.get(`${this.base}/Delete`, { params: { id } });
  }
}
